export default __webpack_public_path__ + "static/media/Program_disabled.21c34545.jpg";